import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import ChipExample from '../examples/Chip';
const ChipExampleSource = require('!!raw-loader!../examples/Chip');
const ChipPage = () => (<div>
        <Helmet title="Chip"/>
        <h3>Chip</h3>
        <div className="docs-example">
            <ChipExample />
        </div>
        <pre>
            <PrismCode className="language-jsx">{ChipExampleSource}</PrismCode>
        </pre>
        <div>
            <h4>Properties</h4>
            <pre>
                <PrismCode className="language-jsx">
                    {`type Props = {|
    text: string,
    count: number,
    onClick?: Function,
    isSelected: boolean,
    className: string,
|};

Chip.defaultProps = {
   isSelected: false,
   count: 0,
   className: '',
}`}
                </PrismCode>
            </pre>
        </div>
    </div>);
export default ChipPage;
